import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, UpdateWebhookDialogueHandler } from './types';
import WebhookContext from './UpdateWebhookContext';

const { ConfirmationDialogue } = vp;

type WebhookDialogueProps = {
  handleDialogue: DialogueHandler<UpdateWebhookDialogueHandler>;
};

type FC = FunctionComponent<WebhookDialogueProps>;

const UpdateWebhookDialogue: FC = ({ handleDialogue }: WebhookDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, updateErrors } = useContext(WebhookContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks.Update.Dialogs' });
  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title={t('UpdateError.title', { defaultValue: 'Error! The webhook was not updated.' })}
          status="error"
          subTitle={
            <ul style={{ textAlign: 'left', margin: 0 }}>
              {updateErrors.map((error) => (
                <li key={error.label}>{`${error.label}: ${error.message}`}</li>
              ))}
            </ul>
          }
          confirm={{
            label: t('UpdateError.confirmButton', { defaultValue: 'Back to Webhook' }),
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title={t('UpdateSuccess.title', { defaultValue: 'Success! The webhook was updated.' })}
          status="success"
          subTitle={t('UpdateSuccess.subTitle', { defaultValue: 'Navigate back to webhooks.' })}
          confirm={{
            label: t('UpdateSuccess.confirmButton', { defaultValue: 'Back to Webhook' }),
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert, updateErrors],
  );
};

export default UpdateWebhookDialogue;
